/**
 * New Frontend System (NFS) entry point for the techdocs-code-theme module.
 *
 * @alpha
 */

import { createFrontendModule } from "@backstage/frontend-plugin-api";
import { TechDocsAddonLocations } from "@backstage/plugin-techdocs-react";
import { AddonBlueprint } from "@backstage/plugin-techdocs-react/alpha";

import { CodeHighlightTheme as CodeHighlightThemeAddon } from "./components/CodeHighlightTheme";
import { CodeSettings as CodeSettingsAddon } from "./components/CodeSettings";

/** @alpha */
const techDocsCodeHighlightThemeAddon = AddonBlueprint.make({
    name: "code-highlight-theme",
    params: {
        name: "CodeHighlightTheme",
        location: TechDocsAddonLocations.Content,
        component: CodeHighlightThemeAddon,
    },
});

/** @alpha */
const techDocsCodeSettingsAddon = AddonBlueprint.make({
    name: "code-settings",
    params: {
        name: "CodeSettings",
        location: TechDocsAddonLocations.Settings,
        component: CodeSettingsAddon,
    },
});

/**
 * Combined NFS module registering both the syntax-highlighting content
 * addon and the code-viewer settings panel under the techdocs plugin.
 *
 * Exported as default so NFS auto-discovery (packageDetection reads
 * `require(pkg).default`) picks it up via `app.packages: all`.
 *
 * @alpha
 */
const techDocsCodeThemeModule = createFrontendModule({
    pluginId: "techdocs",
    extensions: [techDocsCodeHighlightThemeAddon, techDocsCodeSettingsAddon],
});

export default techDocsCodeThemeModule;

/** @alpha */
export const techDocsCodeHighlightThemeModule = createFrontendModule({
    pluginId: "techdocs",
    extensions: [techDocsCodeHighlightThemeAddon],
});

/** @alpha */
export const techDocsCodeSettingsModule = createFrontendModule({
    pluginId: "techdocs",
    extensions: [techDocsCodeSettingsAddon],
});
